import {ApiClient as Api} from '@hconnect/apiclient'
import {useNotification} from '@hconnect/uikit'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {SlaTrackingQueryKey} from '../../types'

type Props = {
  plantUpmId: string
  kpiValueId: string
}

type EditCommentParameter = {
  commentId: string
  commentText: string
}

export const useEditSlaKpiComment = ({plantUpmId, kpiValueId}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()
  const {notify} = useNotification()

  return useMutation<void, AxiosError, EditCommentParameter>({
    mutationFn: async ({commentId, commentText}) => {
      const path = `/sla-kpi-tracking/api/${plantUpmId}/sla-kpi/tab-values/${kpiValueId}/comments/${commentId}`
      await Api.axiosInstance.put(path, {commentText})
    },
    onSuccess: () => {
      notify('success', t('comments.message.editSuccess'))
      void client.invalidateQueries({
        queryKey: [SlaTrackingQueryKey.SlaKpiTabValueEvents, plantUpmId, kpiValueId]
      })
      void client.invalidateQueries({queryKey: [SlaTrackingQueryKey.SlaKpiComments]})
    },
    onError: () => {
      notify('error', t('comments.message.failedToUpdateComment'))
    }
  })
}
